<template>
  <div class="new_submit_prod" id="new_submit_prod">
    <div class="ln_head">
      <div class="close_text" @click="handleClose">Done</div>
    </div>
    <div class="prod">
      <div class="prod_b">
        <div class="part-title">{{ $t('common.confirm') }}</div>
        <div class="order_total">
          <div>{{ $t('paySubmit.total') }}</div>
          <div class="blod">{{ `${area_val == 'kr' ? '₩' : '$'}` + detailData.amount }}</div>
        </div>
      </div>
      <div class="prod_b">
        <div class="prod_title">
          <div class="part-title">
            <div class="title_detail">
              {{ $t('paySubmit.paymentMethods') }}
              <van-popover
                trigger="click"
                :actions="countryList"
                v-model="showCountryList"
                @select="onCountrySelect"
                placement="bottom-end"
                get-container="#new_submit_prod"
              >
                <template #reference>
                  <div class="country_seleted needsclick">
                    <div class="current_region needsclick">
                      {{ $t('paySubmit.currentRegion') }}: {{ selectedCountry.text }}
                    </div>
                    <div class="needsclick">
                      <van-icon v-if="showCountryList" name="arrow-down" color="#28C0FF" />
                      <van-icon v-else name="arrow-up" color="#28C0FF" />
                    </div>
                  </div>
                </template>
              </van-popover>
            </div>
          </div>
        </div>
        <div class="pay_methods">
          <van-radio-group v-model="pay_channel_method_id">
            <div class="top_methods">
              <div class="top_method">
                <van-cell 
                  v-for="item in payWaysList.slice(0, 2)"
                  :key="item.name"
                  :border="false"
                  clickable
                  @click="handleSelectPayWay(item)"
                >
                  <template #title>
                    <div class="payWay">
                      <div class="payWay_a"><img :src="item.logo_url_2" alt="" /></div>
                      <div class="payWay_b">
                        <div class="name">{{ `${item.pay_type}—${item.pay_method}` }}</div>
                      </div>
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio :name="item.id" icon-size="14" checked-color="#7c7c7c" />
                  </template>
                </van-cell>
              </div>
              <div class="payway_arrow" @click="handleShowMorePayWay">
                <div v-if="payWaysList.length > 2">
                  <van-icon v-if="showMorePayWay" name="arrow-down" color="#28C0FF" />
                  <van-icon v-else name="arrow" color="#28C0FF" />
                </div>
              </div>
            </div>
            <div class="other_methods" v-if="showMorePayWay">
              <van-cell 
                v-for="item in payWaysList.slice(2)"
                :key="item.name"
                :border="false"
                clickable
                @click="handleSelectPayWay(item)"
              >
                <template #title>
                  <div class="payWay">
                    <div class="payWay_a"><img :src="item.logo_url_2" alt="" /></div>
                    <div class="payWay_b">
                      <div class="name">{{ `${item.pay_type}—${item.pay_method}` }}</div>
                    </div>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="item.id" icon-size="14" checked-color="#7c7c7c" />
                </template>
              </van-cell>
            </div>
          </van-radio-group>
        </div>
      </div>
      <div class="prod_b">
        <div class="part-title">{{ $t('paySubmit.items') }}</div>
      </div>
      <div class="prod_c">
        <div class="item_info">
          <div class="img-inner">
            <img :src="detailData.product_file_url" alt="" />
          </div>
          <div class="info_detail">
            <div class="type">{{ detailData.type }}</div>
            <div class="product_name">{{ detailData.product_name }}</div>
            <div class="amount_content">
              <div class="extra-tag" v-if="detailData.first_buy == 1 && detailData.first_pay_icon">{{ detailData.first_pay_icon }}</div>
              <div class="extra-tag" v-if="detailData.first_buy == 0 && detailData.pay_icon">{{ detailData.pay_icon }}</div>
              <div class="amount">{{ `${area_val == 'kr' ? '₩' : '$'}` + detailData.amount }}</div>
            </div>
            <div class="role_info">
              <div>{{ $t('pay.Server') }}: {{ roleInfo.server_name }}</div>
              <div>{{ $t('pay.CharacterID') }}: {{ roleInfo.role_id }}</div>
              <div>{{ $t('pay.RoleName') }}: {{ roleInfo.role_name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm_box">
      <div class="confirm_btn" @click="submitOrder">{{ $t('common.confirm') }}</div>
    </div>
  </div>
</template>

<script>
// import { getServerList, getRoleInfo, submitPay, valDiscountCode } from '@/api/api';
import { mapState } from 'vuex';
import { axiosServer } from '@/api/http';
import { getSign } from '@/api/utils';
import { getUrlParams } from '@/utils';
import { Dialog, Toast, ImagePreview } from 'vant';
import cust from '../../components/customer.vue';
import { useDialog } from '../../features/dialog/use-dialog';

export default {
  dialogify: {
    showConfirmButton: false,
    position: 'bottom',
    class: 'submit_dialog'
  },
  props: {
    detailData: {
      type: Object,
      default: () => ({})
    },
    isPc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRole: false,
      roleInfo: {},
      area_id: 'us',
      code: '',
      game_id: localStorage.getItem('game_id'),
      area_val: localStorage.getItem('area'),
      discount_code: '',
      money: '',
      codeEnter: false,
      pa_game: false,
      app_key: '1df869f2e620513484ddbd5521313a60',
      payWays: JSON.parse(localStorage.getItem('payWays')),
      isRolePop: false,
      roleImgUrl: '',

      selectedCountry: {
        sign: "",
        text: "",
      },
      showCountryList: false,
      countryList: [],
      pay_channel_method_id: "",
      payWaysList: [],
      showMorePayWay: false,
      pay_method_list: [],
    };
  },
  components: {
  },
  computed: {
    // ...mapState(['payWays'])
  },
  setup() {
    const { confirmDialog, onCancel, getCurrentDialog } = useDialog();
    return {
      confirmDialog,
      onCancel,
      getCurrentDialog
    };
  },
  created() {
    // this.pa_game = this.game_id == 18 && (this.area_val == 'us' || this.area_val == 'eu');
    // console.log(this.detailData);
    if(this.isPc) {
      const payload = { action: 'max' };
      window.parent.postMessage(payload, '*');
    }
    this.roleInfo = this.detailData.roleInfo && JSON.parse(this.detailData.roleInfo);
    this.getCashierConfig();
  },
  methods: {
    getCashierConfig() {
      axiosServer({
        url: 'getCashierConfig',
        type: 'post',
        params: {
          game_id: localStorage.getItem('game_id'),
          area: localStorage.getItem('area'),
          sign: getSign(this.app_key, { game_id: localStorage.getItem('game_id'), area: localStorage.getItem('area') })
        }
      }).then(res => {
        let resa = res.data;
        if (resa.ret == 0) {
          if(resa.data.country_list) {
            this.countryList = Object.keys(resa.data.country_list).map((key) => {
              return {
                sign: key,
                text: resa.data.country_list[key]
              }
            });
            this.payWaysList = resa.data.default_pay_method_list;
            if(this.payWaysList.length) {
              this.pay_channel_method_id = this.payWaysList[0].id;
            }
            this.pay_method_list = resa.data.pay_method_list;
            let key = Object.keys(resa.data.default_country)[0];
            this.selectedCountry.text = resa.data.default_country[key];
          }

        } else {
          this.confirmDialog({
            message: resa.msg
          });
        }
      });
    },
    onCountrySelect(action) {
      console.log(action)
      this.selectedCountry.sign = action.sign;
      this.selectedCountry.text = action.text;
      this.payWaysList = this.pay_method_list[action.sign] ? this.pay_method_list[action.sign] : [];
      this.pay_channel_method_id = "";
      if(this.payWaysList.length) {
        this.pay_channel_method_id = this.payWaysList[0].id;
      }
      this.showMorePayWay = false;
    },

    handleClose() {
      this.getCurrentDialog().cancel();
    },
    handleSelectPayWay(item) {
      this.pay_channel_method_id = item.id
    },
    handleShowMorePayWay() {
      this.showMorePayWay = !this.showMorePayWay
    },
    changePayWay(index) {
      this.payWays.forEach(v => {
        v.checked = false;
      });
      this.$set(this.payWays[index], 'checked', true);
    },
    reportEvent(event) {
      let params = {
        game_id: localStorage.getItem('game_id'),
        area: localStorage.getItem('area'),
        product_id: this.detailData.id,
        product_type: this.detailData.type,
        report_type: event,
        from: localStorage.getItem('from')
      };
      axiosServer({
        url: 'report',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(res => {
        console.log(res);
      });
    },
    submitOrder() {
      this.reportEvent(5);
      if (this.discount_code && !this.codeEnter) {
        const paramsCode = {
          game_id: this.game_id,
          role_id: this.roleInfo.role_id,
          amount: this.detailData.amount,
          discount_code: this.discount_code,
          product_id: this.detailData.id,
          area: this.pa_game ? this.area_id : localStorage.getItem('area')
        };

        axiosServer({
          url: 'valDiscountCode',
          type: 'post',
          params: {
            ...paramsCode,
            sign: getSign(this.app_key, paramsCode)
          }
        }).then(resa => {
          let res = resa.data;
          this.codeEnter = true;
          if (res.ret == 0) {
            this.money = res.data.money;
          } else {
            this.confirmDialog({
              message: res.msg
            });
          }
          this.payCommonFunc();
        });
      } else {
        this.payCommonFunc();
      }
    },
    payCommonFunc() {
      Toast.loading();
      console.log(this.roleInfo);
      let params = {
        order_name: this.detailData.product_name,
        amount: this.detailData.amount,
        money: this.money ? this.money : this.detailData.amount,
        server_id: this.roleInfo.server_id,
        server_name: this.roleInfo.server_name,
        role_name: this.roleInfo.role_name,
        product_id: this.detailData.shop_mark,
        platform: this.detailData.platform,
        pay_type: this.payWays.filter(item => item.checked)[0].name,
        role_id: this.roleInfo.role_id,
        discount_code: this.discount_code,
        area: this.pa_game ? this.area_id : localStorage.getItem('area'),
        game_id: this.game_id,
        from: localStorage.getItem('from'),
        pay_channel_method_id: this.pay_channel_method_id,
        ...(this.game_id == '134' && {server_sign: this.detailData.server_sign})
      };
      axiosServer({
        url: 'submitPay',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(resa => {
        let res = resa.data;
        Toast.clear();
        if (res.ret == 0) {
          if(this.isPc) {
            const payload = { action: 'pay', url: res.data.pay_url};
            window.parent.postMessage(payload, '*');
          }else {
            location.href = res.data.pay_url;
          }
        } else {
          this.confirmDialog({
            message: res.msg
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.new_submit_prod {
  width: 7.2rem;
  height: 100%;
  height: 100dvh;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  /deep/.van-cell {
    padding: 0.3rem 0.5rem 0.3rem 0.6rem;
    background-color: transparent;
  }
  .blod {
    font-weight: bold;
  }
  .part-title {
    padding-bottom: 0; // 这个页面下的part_title都不需要padding-bottom
    padding-left: 0.18rem;
  }
  .ln_head {
    width: 100%;
    background: white;
    height: 1.16rem;
    display: flex;
    align-items: center;
    .close_text {
      font-size: 0.32rem;
      color: #28C0FF;
      font-weight: 500;
      margin-left: 0.69rem;
    }
  }
  .prod {
    flex: 1;
    overflow-y: auto;
  }
  .prod_b {
    padding: 0.13rem 0.28rem;

    div {
      line-height: 0.5rem;
    }
    .order_total {
      font-size: 0.24rem;
      display: flex;
      justify-content: space-between;
      margin-left: 0.41rem;
      margin-top: 0.1rem;
    }
    .country_seleted {
      color: #7C7C7C;
      font-size: 0.2rem;
      font-weight: 500;
      display: flex;
    }
    .current_region {
      max-width: 3rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .title_detail {
      width: 100%;
      display: flex;
      align-items: baseline;
      justify-content: space-between;
    }
    .pay_methods {
      width: 100%;
      padding-left: 0.18rem;
      margin-top: 0.48rem;
      .top_methods {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 0.2rem;
        box-shadow: 0 2px 2px 2px  rgba(231,232,233,0.5);
        /deep/.van-cell {
          padding-right: 0.1rem;
          padding-left: 0.4rem;
        }
      }
      .top_method {
        flex: 1;
      }
      .payway_arrow {
        width: 0.4rem;
      }
      .other_methods {
        border-radius: 0.2rem;
        box-shadow: 0 2px 2px 2px  rgba(231,232,233,0.5);
        /deep/.van-cell {
          padding-left: 0.4rem;
        }
      }
      .payWay {
        display: flex;
        align-items: center;
      }
      .payWay_a {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.3rem;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        img {
          width: 100%;
        }
      }
      .payWay_b {
        font-size: 0.24rem;
        display: flex;
        flex-direction: column;
        font-weight: 500;
        .order {
          color: #7C7C7C;
        }
        .name, .order {
          line-height: 0.4rem;
        }
      }
    }
  }
  .prod_c {
    margin: 0.24rem 0;
    padding: 0 0.28rem;
    background-color: #fff;
    .item_info {
      display: flex;
      padding:  0.35rem 0 0.4rem 0.18rem;
      .img-inner {
        width: 1.7rem;
        height: 1.7rem;
        margin-right: 0.2rem;
        position: relative;
        > img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 0.1rem;
          background: #f1f1f1;
        }
      }
      .info_detail {
        .type {
          color: #7C7C7C;
          font-size: 0.25rem;
        }
        .product_name {
          font-size: 0.3rem;
          font-weight: bold;
        }
        .amount_content {
          display: flex;
          align-items: center;
          margin: 0.1rem 0;
        }
        .amount {
          margin-left: 0.1rem;
          font-size: 0.25rem;
          font-weight: bold;
        }
        .role_info {
          font-size: 0.22rem;
          font-weight: bold;
          color: #7C7C7C;
          div {
            margin-bottom: 0.05rem;
          }
        }
        .extra-tag {
          width: fit-content;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 0.4rem;
          padding: 0 0.12rem;
          background: #fe0000;
          font-family: SourceHanSansCN;
          font-weight: 800;
          font-size: 0.24rem;
          color: #ffffff;
        }
      }
    }
  }
  .confirm_box {
    height: 1.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    .confirm_btn {
      color: #fff;
      width: 5.28rem;
      height: 0.58rem;
      padding: 0.2rem 0.4rem;
      border-radius: 0.1rem;
      font-size: 0.26rem;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #28C0FF;
    }
  }
}
</style>